import React from 'react';
import { NavLink } from 'react-router-dom';
import type { NavItem } from '../utils/navMap';

/** The rooms behind one door. Links, so each tab has its own URL; NavLink sets aria-current.
 *  The list pads 4px on every side and the nav pulls the same back, so the
 *  2px ring + 2px offset is never clipped by overflow-x-auto and the strip
 *  sits exactly where it did. */
export default function SectionTabs({ label, tabs }: { label: string; tabs: NavItem[] }) {
  return (
    <nav aria-label={label} className="mb-5 -mx-1 -mt-1 overflow-x-auto">
      <ul className="flex min-w-max gap-2 px-1 py-1">
        {tabs.map((t) => (
          <li key={t.path}>
            <NavLink
              to={t.path}
              className={({ isActive }) =>
                `inline-flex h-9 items-center rounded-badge px-4 font-sans text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4A2D5E] focus-visible:ring-offset-2 focus-visible:ring-offset-[#FAF9F7] ${
                  isActive
                    ? 'bg-[#4A2D5E] text-white'
                    : 'border border-[#E6E2DE] bg-white text-[#6B6670] hover:border-[#4A2D5E]/40 hover:text-[#2D2A2E]'
                }`}
            >
              {t.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
